(() => {
  const SELECTORS = {
    gallery: '[data-hgl-video-gallery]',
    scroll: '[data-video-gallery-scroll]',
    arrow: '[data-video-gallery-arrow]',
  };

  const clamp = (v, min, max) => Math.max(min, Math.min(max, v));

  const updateArrows = (scrollEl, prevBtn, nextBtn) => {
    if (!prevBtn && !nextBtn) return;

    const maxScrollLeft = scrollEl.scrollWidth - scrollEl.clientWidth;
    const hasOverflow = maxScrollLeft > 2;

    const atStart = scrollEl.scrollLeft <= 2;
    const atEnd = scrollEl.scrollLeft >= maxScrollLeft - 2;

    if (prevBtn) prevBtn.hidden = !hasOverflow || atStart;
    if (nextBtn) nextBtn.hidden = !hasOverflow || atEnd;
  };

  const setupGallery = (galleryEl) => {
    const scrollEl = galleryEl.querySelector(SELECTORS.scroll);
    if (!scrollEl) return;

    const prevBtn = galleryEl.querySelector(`${SELECTORS.arrow}[data-video-gallery-arrow="prev"]`);
    const nextBtn = galleryEl.querySelector(`${SELECTORS.arrow}[data-video-gallery-arrow="next"]`);

    if (prevBtn) prevBtn.addEventListener('click', () => scrollByStep(scrollEl, -1));
    if (nextBtn) nextBtn.addEventListener('click', () => scrollByStep(scrollEl, 1));

    const onUpdate = () => updateArrows(scrollEl, prevBtn, nextBtn);

    scrollEl.addEventListener('scroll', () => window.requestAnimationFrame(onUpdate), { passive: true });
    window.addEventListener('resize', onUpdate, { passive: true });

    const ro = window.ResizeObserver
      ? new ResizeObserver(() => onUpdate())
      : null;
    ro?.observe(scrollEl);

    // Initial state (after layout)
    window.requestAnimationFrame(onUpdate);
  };

  const scrollByStep = (scrollEl, direction) => {
    const step = clamp(Math.round(scrollEl.clientWidth * 0.9), 240, 900);
    scrollEl.scrollBy({ left: step * direction, behavior: 'smooth' });
  };

  const init = (root = document) => {
    root.querySelectorAll(SELECTORS.gallery).forEach((galleryEl) => setupGallery(galleryEl));
  };

  document.addEventListener('DOMContentLoaded', () => init(document));
  document.addEventListener('product-info:loaded', (e) => {
    const root = e?.target instanceof Element ? e.target : document;
    init(root);
  });
})();

